<template>
    <div v-if="itemsForPage.length" class="help-section">
        <div>
            <b-dropdown id="dropdown-help-section" text="" class="m-2">
                <header class="help-section__header">
                    <b-dropdown-item-button aria-describedby="" class="help-section__close">
                    </b-dropdown-item-button>

                    <h3 class="help-section__title">Help</h3>

                    <div class="help-section__search">
                        <input v-model="filter" v-debounce:500ms.lock="getFilteredItems" type="text" placeholder="Search our knowledgebase"/>
                    </div>
                </header>

                <div class="help-section__inner">
                    <template v-if="videos.length">
                        <h4 class="heading4 heading4--play">Videos</h4>
                            <ul class="list-help">
                                <li v-for="(item, index) in videos" :key="index">
                                    <a @click="() => {showVideo(item.source_id)}">{{item.name}}</a>
                                </li>
                            </ul>
                    </template>
                    <template v-if="knowledgeBases.length">
                        <h4 class="heading4 heading4--knowledge">Knowledgebase</h4>

                            <ul class="list-help">
                                <li v-for="(item, index) in knowledgeBases" :key="index">
                                    <a @click="showArticle(item)">{{item.name}}</a>
                                </li>
                            </ul>
                    </template>
                </div>
                <footer class="help-section__footer">
                    <h4 class="heading4 heading4--help" style="">Get Help</h4>

                    <div class="help-section__footer__buttons">
                        <a
                            class="help-section__button help-section__button--report"
                            @click="$refs.messageModal.show()"
                        >
                            Report An Issue
                        </a>
<!--                        <a href="#" class="help-section__button help-section__button&#45;&#45;contact">Contact Us</a>-->
                    </div>
                </footer>
            </b-dropdown>
        </div>

<!--        <div class="help-section__content" v-if="!isHidden">-->
<!--            <header class="help-section__header">-->
<!--                <a class="help-section__close" href="#" v-on:click="isHidden = true"></a>-->
<!--                <h3 class="help-section__title">Help</h3>-->

<!--                <div class="help-section__search">-->
<!--                    <input v-model="filter" v-debounce:500ms.lock="getFilteredItems" type="text" placeholder="Search walkthroughs & knowledgebase"/>-->
<!--                </div>-->
<!--            </header>-->

<!--            <div class="help-section__inner">-->
<!--                <template v-if="walkThroughs.length">-->
<!--                    <h4 class="heading4 heading4&#45;&#45;mouse">Walkthroughs</h4>-->

<!--                    <div class="card card&#45;&#45;bordered-slim">-->
<!--                        <ul class="list-mouse">-->
<!--                            <li v-for="(item, index) in walkThroughs" :key="index">-->
<!--                                <a @click="() => {startWalkthrough(item.source_id)}" target="_blank">{{item.name}}</a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </template>-->

<!--                <template v-if="knowledgeBases.length">-->
<!--                    <h4 class="heading4 heading4&#45;&#45;knowledge">Knowledgebase</h4>-->

<!--                    <div class="card card&#45;&#45;bordered-slim">-->
<!--                        <ul class="list-knowledge">-->
<!--                            <li v-for="(item, index) in knowledgeBases" :key="index">-->
<!--                                <a :href="item.source_id" target="_blank">{{item.name}}</a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </template>-->

<!--                <template v-if="videos.length">-->
<!--                    <h4 class="heading4 heading4&#45;&#45;knowledge">Videos</h4>-->

<!--                    <div class="card card&#45;&#45;bordered-slim">-->
<!--                        <ul class="list-knowledge">-->
<!--                            <li v-for="(item, index) in videos" :key="index">-->
<!--                                <a @click="() => {showVideo(item.source_id)}" target="_blank">{{item.name}}</a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </template>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="help-section__button">-->
<!--            <span class="help-section__button__text">Help</span>-->
<!--        </div>-->

        <b-modal v-model="showArticleModal" modal-class="modal-help modal-w-xl" :hide-footer="true">
            <div class="modal-wrapper__content" v-html="articleText"/>
        </b-modal>

        <video-modal
            ref="videoModal"
        />

        <MessageToManagerModal
            ref="messageModal"
            type="issueReport"
            title="Describe the Issue"
            body="Please tell us what happened. Include any relevant details you think might be helpful."
        />
    </div>
</template>

<script>
import helperItemsService from "@/services/helper-items.service";
import VideoModal from "@/components/widgets/VideoModal.vue";
import MessageToManagerModal from "@/components/MessageToManagerModal.vue";

export default {
    components: {MessageToManagerModal, VideoModal},
    props: {
        page: String
    },

    data() {
        return {
            items: [],
            itemsForPage: [],
            filter: '',
            showArticleModal: false,
            articleText: ''
        }
    },

    computed: {
        knowledgeBases() {
            return this.items.filter(item => item.type === 'knowledge_base')
        },

        videos() {
            return this.items.filter(item => item.type === 'video')
        }
    },

    mounted() {
        this.getItemsForPage();
    },

    methods: {
        getItemsForPage() {
            helperItemsService.getItems(this.page).then(response => {
                this.itemsForPage = response.data
                this.items = response.data
            })
        },

        getFilteredItems() {
            if (this.filter.length) {
                helperItemsService.getItems(this.page, this.filter).then(response => {
                    this.items = response.data
                })
            } else {
                this.items = [...this.itemsForPage];
            }
        },

        showArticle(item) {
            if (item.internal_article) {
                this.articleText = item.text;
                this.showArticleModal = true;
            } else {
                window.open(item.source_id, '_blank').focus();
            }
        },

        showVideo(id) {
            this.$refs.videoModal.show(`https://player.vimeo.com/video/${id}`);
        }
    },
}
</script>

<style scoped>

</style>
